function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useContext, useRef, useState, useMemo } from 'react';
import { SearchIcon } from '@shopify/polaris-icons';
import { Key } from '../../types.js';
import { wrapFocusPreviousFocusableMenuItem, wrapFocusNextFocusableMenuItem } from '../../utilities/focus.js';
import { FilterActionsContext } from '../FilterActionsProvider/FilterActionsProvider.js';
import { Section } from './components/Section/Section.js';
import { KeypressListener } from '../KeypressListener/KeypressListener.js';
import { TextField } from '../TextField/TextField.js';
import { useI18n } from '../../utilities/i18n/hooks.js';
import { Box } from '../Box/Box.js';
import { Icon } from '../Icon/Icon.js';
import { Item } from './components/Item/Item.js';
var FILTER_ACTIONS_THRESHOLD = 8;
function ActionList(_ref) {
  var _finalSections, _finalSections2, _finalSections3;
  var items = _ref.items,
    _ref$sections = _ref.sections,
    sections = _ref$sections === void 0 ? [] : _ref$sections,
    actionRole = _ref.actionRole,
    allowFiltering = _ref.allowFiltering,
    onActionAnyItem = _ref.onActionAnyItem;
  var i18n = useI18n();
  var filterActions = useContext(FilterActionsContext);
  var finalSections = [];
  var actionListRef = useRef(null);
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchText = _useState2[0],
    setSeachText = _useState2[1];
  if (items) {
    finalSections = [{
      items: items
    }].concat(_toConsumableArray(sections));
  } else if (sections) {
    finalSections = sections;
  }
  var isFilterable = (_finalSections = finalSections) === null || _finalSections === void 0 ? void 0 : _finalSections.some(function (section) {
    return section.items.some(function (item) {
      return typeof item.content === 'string';
    });
  });
  var hasMultipleSections = finalSections.length > 1;
  var elementRole = hasMultipleSections && actionRole === 'menuitem' ? 'menu' : undefined;
  var elementTabIndex = hasMultipleSections && actionRole === 'menuitem' ? -1 : undefined;
  var filteredSections = (_finalSections2 = finalSections) === null || _finalSections2 === void 0 ? void 0 : _finalSections2.map(function (section) {
    return _objectSpread(_objectSpread({}, section), {}, {
      items: section.items.filter(function (_ref2) {
        var content = _ref2.content;
        return typeof content === 'string' ? content === null || content === void 0 ? void 0 : content.toLowerCase().includes(searchText.toLowerCase()) : content;
      })
    });
  });
  var sectionMarkup = filteredSections.map(function (section, index) {
    return section.items.length > 0 ? /*#__PURE__*/React.createElement(Section, {
      key: typeof section.title === 'string' ? section.title : index,
      section: section,
      hasMultipleSections: hasMultipleSections,
      actionRole: actionRole,
      onActionAnyItem: onActionAnyItem,
      isFirst: index === 0
    }) : null;
  });
  var handleFocusPreviousItem = function handleFocusPreviousItem(evt) {
    evt.preventDefault();
    if (actionListRef.current && evt.target) {
      if (actionListRef.current.contains(evt.target)) {
        wrapFocusPreviousFocusableMenuItem(actionListRef.current, evt.target);
      }
    }
  };
  var handleFocusNextItem = function handleFocusNextItem(evt) {
    evt.preventDefault();
    if (actionListRef.current && evt.target) {
      if (actionListRef.current.contains(evt.target)) {
        wrapFocusNextFocusableMenuItem(actionListRef.current, evt.target);
      }
    }
  };
  var listeners = actionRole === 'menuitem' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(KeypressListener, {
    keyEvent: "keydown",
    keyCode: Key.DownArrow,
    handler: handleFocusNextItem
  }), /*#__PURE__*/React.createElement(KeypressListener, {
    keyEvent: "keydown",
    keyCode: Key.UpArrow,
    handler: handleFocusPreviousItem
  })) : null;
  var totalFilteredActions = useMemo(function () {
    var totalSectionItems = (filteredSections === null || filteredSections === void 0 ? void 0 : filteredSections.reduce(function (acc, section) {
      return acc + section.items.length;
    }, 0)) || 0;
    return totalSectionItems;
  }, [filteredSections]);
  var totalActions = ((_finalSections3 = finalSections) === null || _finalSections3 === void 0 ? void 0 : _finalSections3.reduce(function (acc, section) {
    return acc + section.items.length;
  }, 0)) || 0;
  var hasManyActions = totalActions >= FILTER_ACTIONS_THRESHOLD;
  return /*#__PURE__*/React.createElement(React.Fragment, null, (allowFiltering || filterActions) && hasManyActions && isFilterable && /*#__PURE__*/React.createElement(Box, {
    padding: "200",
    paddingBlockEnd: totalFilteredActions > 0 ? '0' : '200'
  }, /*#__PURE__*/React.createElement(TextField, {
    clearButton: true,
    labelHidden: true,
    label: i18n.translate('Polaris.ActionList.SearchField.placeholder'),
    placeholder: i18n.translate('Polaris.ActionList.SearchField.placeholder'),
    autoComplete: "off",
    value: searchText,
    onChange: function onChange(value) {
      return setSeachText(value);
    },
    prefix: /*#__PURE__*/React.createElement(Icon, {
      source: SearchIcon
    }),
    onClearButtonClick: function onClearButtonClick() {
      return setSeachText('');
    }
  })), /*#__PURE__*/React.createElement(Box, {
    as: hasMultipleSections ? 'ul' : 'div',
    ref: actionListRef,
    role: elementRole,
    tabIndex: elementTabIndex
  }, listeners, sectionMarkup));
}
ActionList.Item = Item;
export { ActionList };